import React from 'react';
import { NavMenu } from './NavMenu';

export function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#090a0f] text-slate-100 flex flex-col font-sans">
      <NavMenu />
      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
      <footer className="border-t border-slate-800/80 bg-[#11131a] py-4 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500 gap-2">
          <p>© 2026 Lite Charms (PTY) Ltd. LiteID Control Plane.</p>
          <p className="font-mono text-[11px] text-slate-400">
            Engine: .NET 10 • PostgreSQL 17 • React • Tailwind CSS
          </p>
        </div>
      </footer>
    </div>
  );
}
